import CaseStudyCard from "../../reusables/CaseStudyCard";
import dylan from "../../../assets/images/case-studies/dylan.jpg";

const DylanCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={dylan}
      client="Dylan Medical Services"
      solution="Brand Setup"
      title="Digital brand identity setup and web app development for a medical startup"
      subtitle="This medical startup wanted to use technology to penetrate the health services industry"
      link="/solutions/branding-graphic-design"
    >
      <li>
        ✔︎ <span>Logo design</span>
      </li>
      <li>
        ✔︎ <span>Brand Identity design</span>
      </li>
      <li>
        ✔︎ <span>Social media setup</span>
      </li>
      <li>
        ✔︎ <span>Web app development</span>
      </li>
      <li>
        ✔︎ <span>Google business profile</span>
      </li>
    </CaseStudyCard>
  );
};

export default DylanCaseStudyCard;
